export interface PromptMetadata {
  version: string;
  last_updated: string;
  size: number;
  author: string;
}

export interface PromptVersion {
  version: string;
  timestamp: string;
  size: number;
  gcs_path: string;
}

export interface PromptResponse {
  name: string;
  content: string;
  metadata?: PromptMetadata;
}

export interface PromptVersionsResponse {
  versions: PromptVersion[];
}

export interface PromptUpdateRequest {
  content: string;
}

export interface RestoreRequest {
  version: string;
}

export interface DiffResponse {
  from_version: string;
  to_version: string;
  diff: string;
  added_lines: number;
  removed_lines: number;
  changed_lines: number;
}

// UI-specific types
export interface PromptButtonInfo {
  name: string;
  label: string;
  icon: string;
  description: string;
}

export interface PromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  promptName: string;
}

// Available prompts configuration
export const AVAILABLE_PROMPTS: PromptButtonInfo[] = [
  {
    name: 'workhorse',
    label: 'Workhorse',
    icon: '⚙️',
    description: ''
  },
  {
    name: 'chat_query_narrative',
    label: 'Chat Analysis',
    icon: '💬',
    description: ''
  },
  {
    name: 'generate_final_insights',
    label: 'Final Insights',
    icon: '🎯',
    description: ''
  },
  {
    name: 'context_summary',
    label: 'Context Summary',
    icon: '📋',
    description: ''
  }
];

// API Error types
export interface ApiError {
  detail: string;
}
